import { render, staticRenderFns } from "./UserCollection.vue?vue&type=template&id=09be24c7"
import script from "./UserCollection.vue?vue&type=script&lang=js"
export * from "./UserCollection.vue?vue&type=script&lang=js"
import style0 from "./UserCollection.vue?vue&type=style&index=0&id=09be24c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports